/**
 * The name Vera greets someone by. A nickname in double quotes wins, so an
 * Entra display name of `Robert "Bob" Smith` greets Bob; otherwise it is the
 * first word, as before (ADO #1669). Single quotes are not nickname marks:
 * they appear inside real names (O'Brien).
 */
export function firstNameOf(name: string | null | undefined): string {
  const s = (name ?? '').trim();
  const nick = s.match(/["“”]([^"“”]+)["“”]/);
  const nickname = nick?.[1]?.trim();
  if (nickname) return nickname;
  return s.split(/\s+/)[0] ?? '';
}
